import { motion } from "framer-motion";
import { Breadcrumbs } from "./Breadcrumbs";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedReveal = ({
  lines,
  innerClassName = "",
  delay = 0.15,
  inView = false,
}) => (
  <>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
        <motion.span
          className={`block ${innerClassName}`}
          initial={{ y: "115%" }}
          {...(inView
            ? { whileInView: { y: 0 }, viewport: { once: true, margin: "-40px" } }
            : { animate: { y: 0 } })}
          transition={{ duration: 0.9, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </>
);

export const SectionTag = ({ children, dark = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-10 bg-gold" />
    <span
      className={`text-xs font-semibold tracking-[0.25em] uppercase ${
        dark ? "text-gold" : "text-tan"
      }`}
    >
      {children}
    </span>
  </div>
);

export const PageHero = ({ tag, lines, copy, children, testid, crumbs }) => (
  <section
    className="relative bg-cream pt-32 pb-16 md:pt-44 md:pb-24 overflow-hidden"
    data-testid={testid}
  >
    <div className="absolute inset-0 geo-pattern opacity-[0.05]" />
    <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-tan/10 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {crumbs && <Breadcrumbs items={crumbs} />}
        <SectionTag className="mb-7">{tag}</SectionTag>
      </motion.div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-charcoal leading-[1.03] max-w-4xl">
        <MaskedReveal lines={lines} />
      </h1>
      {copy && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
          className="mt-7 max-w-2xl text-base md:text-lg text-charcoal/65 leading-relaxed"
        >
          {copy}
        </motion.p>
      )}
      {children && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.7, ease: EASE }}
          className="mt-9 flex flex-wrap gap-4"
        >
          {children}
        </motion.div>
      )}
    </div>
  </section>
);
